var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnglandFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "united-kingdom-flag-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.2,
    height: 38.4,
    viewBox: "0 0 55.2 38.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M2.87,38.4H52.33a3.052,3.052,0,0,0,2.87-3.03V3.03A3.037,3.037,0,0,0,52.19,0H3.01A3.037,3.037,0,0,0,0,3.03V35.36A3.054,3.054,0,0,0,2.87,38.4Z",
    fill: "#fefefe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M23.74,23.03V38.4h7.68V23.03H55.2V15.35H31.42V0H23.74V15.35H0v7.68Z",
    fill: "#c8102e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M33.98,12.43V0H52.21a3.047,3.047,0,0,1,2.78,1.92L33.98,12.43Z",
    fill: "#012169"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M33.98,25.97V38.4H52.33a3.068,3.068,0,0,0,2.66-1.92L33.98,25.97Z",
    fill: "#012169"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M21.18,25.97V38.4H2.87A3.043,3.043,0,0,1,.21,36.46L21.18,25.97Z",
    fill: "#012169"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M21.18,12.43V0H2.99A3.04,3.04,0,0,0,.21,1.94L21.18,12.43Z",
    fill: "#012169"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M0,12.8H7.65L0,8.97Z",
    fill: "#012169"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M55.2,12.8H47.51L55.2,8.95Z",
    fill: "#012169"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M55.2,25.6H47.51l7.69,3.85Z",
    fill: "#012169"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M0,25.6H7.65L0,29.43Z",
    fill: "#012169"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M55.2,3.25,36.15,12.8h4.26L55.2,5.4Z",
    fill: "#c8102e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M19.01,25.6H14.75L0,32.98v2.15L19.05,25.6Z",
    fill: "#c8102e"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M10.52,12.81h4.26L0,5.41V7.55Z",
    fill: "#c8102e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M44.63,25.59H40.37L55.2,33.02V30.88Z",
    fill: "#c8102e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglandFlag);
export default __webpack_public_path__ + "static/media/england-flag.c362cf6223ab139a7ad614e8172dee87.svg";
export { ForwardRef as ReactComponent };